import { Radio } from 'semantic-ui-react';
import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { useUpdateUserPermissions } from 'services/user/update-permissions';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import { Text } from 'components/typography';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export function ManageAdminPermissions() {
 
  const intl = useIntl();
  const { selectedUser } = useContext(UserAdministrationModalContext);
  const updateUserPermissions = useUpdateUserPermissions(selectedUser);
  const { checkPermissionsByEmail, isLoading: isLoadingForCheckPermission } = useUserPermissionsByEmail(selectedUser.email);
  const hasAdminAccess = checkPermissionsByEmail('admin-users', 'update', 'read', 'create', 'delete');
  const [hasUserAdminAccess, setHasUserAdminAccess] = React.useState(false);
  const { openModal } = useModal();

  useEffect(() => {
    setHasUserAdminAccess(hasAdminAccess);
  }, [hasAdminAccess]);

  return (
    <div className={styles.adminContainer}>
      <Text
        size={20}
        fontWeight={700}
      >
        {intl.formatMessage({ id: 'portalManagement' })}
      </Text>
      <div className={styles.adminAccess}>
       
        <Radio
          label={intl.formatMessage({ id: 'assignAsAdmin' })}
          toggle
          name="setUserAsAdmin"
          checked={Boolean(hasUserAdminAccess)}
          disabled={updateUserPermissions.isLoading || isLoadingForCheckPermission}
          onChange={async (event, value) => {
            setHasUserAdminAccess(value.checked);
            openModal({
              modalType: 'ConfirmationModal',
              modalProps: {
                title: intl.formatMessage({ id: 'updateAdminPermissionForUser' }),
                content: intl.formatMessage({ id: 'updateAdminPermissionForUserContent' }),
                onConfirm: () => {
                  updateUserPermissions.mutate({
                    userEmail: selectedUser.email,
                    permissions: {
                      'admin-users': {
                        update: value.checked,
                        create: value.checked,
                        read: value.checked,
                        delete: value.checked,
                      },
                    },
                  });
                },
              },
            });
          }}
        />
   
      </div>
     
    </div>
  );
}
